import {FINISH_LOGIN_DONE, SET_CLIENT_ID, SET_ERROR_MESSAGE} from "../reducers";
import {API_FE_DOMAIN, API_FE_SUBMIT_CLIENT_FROM_SHOP} from "../constants";
import { put, call } from 'redux-saga/effects';
import axios from "axios";
import {invalidateBtagCookie, invalidatePromocodeCookie} from "../utils";

export default function* submitClientFromShopSaga(action) {
    yield put({ type: FINISH_LOGIN_DONE, payload: 'pending' });

    try {
        const result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_SUBMIT_CLIENT_FROM_SHOP,
            action.payload.body,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        ));

        const response = result.data;

        if (response.status === 1) {
            invalidateBtagCookie();
            invalidatePromocodeCookie();

            yield put({
                type: SET_CLIENT_ID,
                payload: { clientId: response.data.id, mailFrom: response.data.mailFrom },
            });

            if (window.dataLayer != null) {
                window.dataLayer.push({
                    event: 'registrationSuccess',
                    platform: action.payload.body.device.toLowerCase(),
                    user_id: response.data.id
                });
            }

            yield put({ type: FINISH_LOGIN_DONE, payload: 'success' });
        } else {
            yield put({
                type: SET_ERROR_MESSAGE,
                payload: {
                    error: {
                        message: response.error.message,
                        code: response.error.code,
                    },
                    validationErrors: response.data.validationErrors != null ? response.data.validationErrors : null
                },
            });

            yield put({ type: FINISH_LOGIN_DONE, payload: '' });
        }
    } catch (e) {
        yield put({ type: FINISH_LOGIN_DONE, payload: 'error' });
        console.log(e);
    }
}
